import { useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { scrollToElement } from '../../lib/userFunctions';
import { ReadingPhotoPopularBooks } from './ReadingPhotoPopularBooks';
import { ReadingPictureList } from 'app/readingPicture/ReadingPictureList';
import useQueryString from '../../utils/hooks/useQueryString';

const queryString = require('query-string');

export const ReadingPhotoListAll = ()=>{
    const { school } = useParams();
    const queryParams = useQueryString();

    useEffect(() => scrollToElement(), []);

    const paramJson = useMemo(() => {
        const paramJson = { id:null,  isbn:null, user:null, best:'N', keyword:'', school:'', page:0 };
        return {...paramJson, ...queryParams, type:'photo'};
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryParams.school, queryParams.best, queryParams.page]);

    return (
        <div className="subpage">
            <div className="list_page picture _photo">

                <div className="section pdB0">
                    <ReadingPhotoPopularBooks />
                </div>
                
                <div className="section">
                    <div className="tab_menu">
                        <div className="inner">
                            <ul>
                                <li className={`tab1  ${paramJson.best!=='Y'?'on':''}`}>
                                    <Link to={`/${school}/photo?${ queryString.stringify({...queryParams, page:0, best:'N'})}`} >
                                        전체 독서사진
                                    </Link>
                                </li>
                                <li className={`tab2  ${paramJson.best==='Y'?'on':''}`}>
                                    <Link to={`/${school}/photo?${ queryString.stringify({...queryParams, page:0, best:'Y'})}`} >
                                        <span>우수 독서사진</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <ReadingPictureList path={`/${school}/photo`} forcedData={{isbn:null, user:null, type:'photo'}} />
                </div>
            </div>
        </div>
    );
};